import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
// Using a beauty salon image from Unsplash instead of local car wash image

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Professional beauty salon services" />
          </motion.div>
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2>Why Choose Igele Beauty Salon?</h2>
            <p>Located at No9 Cross Crescent Rumuibekwe Port Harcourt, Igele Beauty Salon has been providing premium beauty services with a commitment to excellence and customer satisfaction.</p>
            
            <div className="features">
              {[
                { icon: 'fas fa-award', title: 'Premium Quality', desc: 'We use only the finest beauty products and techniques to ensure you get the best treatment.' },
                { icon: 'fas fa-clock', title: 'Professional Service', desc: 'Expert beauticians who respect your time while delivering exceptional results.' },
                { icon: 'fas fa-heart', title: 'Customer Care', desc: 'Personalized beauty solutions that enhance your natural beauty and boost confidence.' }
              ].map((feature, index) => (
                <motion.div 
                  key={index}
                  className="feature"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                >
                  <div className="feature-icon">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="about-stats"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {[
              { number: '5+', label: 'Years Experience' },
              { number: '1000+', label: 'Happy Customers' },
              { number: '100%', label: 'Satisfaction Rate' }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="stat"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;